import { CadastroModalUtil } from './../../../util/modal/cadastro.modal.util';
import { Component, OnInit } from '@angular/core';
import { FormGroup, Validator, Validators, FormBuilder } from '@angular/forms';
import { ToasterUtilService } from '../../../util/toaster-util.service';
import { SMSModel } from '../../../util/model/sms-aux.model';
import { UtilService } from '../../../util/util.service';
declare var $: any;

@Component({
  selector: 'app-enviar-sms',
  templateUrl: './enviar-sms.component.html',
  styleUrls: ['./enviar-sms.component.scss']
})
export class EnviarSmsComponent implements OnInit {

  tempForm: FormGroup;
  listaNumeros : Array<SMSModel> = [];
  table : any;
  idTable: string = "table#table-sms";


  constructor(
    private fb: FormBuilder,
    private toasterUtil: ToasterUtilService,
    private cadastroModalUtil: CadastroModalUtil

  ) {

  }

  ngOnInit() {
      var self = this;

      this.criarFormGroup();

      $(self.idTable).on('click', 'button.btn-remove-numero', function(e){
        var numero = $(this).data('numero');
        self.cadastroModalUtil.modelSelect = self.removeNumero(numero);
        self.refreshTable();
      });

      self.montarTable();

  }

  montarTable(){
    this.table = $(this.idTable).DataTable(this.configTable());
  }

  refreshTable(){
    this.table.destroy();
    setTimeout(this.montarTable(), 200);
  }

  criarFormGroup(){
    this.tempForm = this.fb.group({
      telefone: [''],
      mensagem: ['Teste de envio de SMS.', Validators.compose([Validators.required, Validators.minLength(5)])]
    });
  }

  removeNumero(numero: string): void{
    this.listaNumeros.forEach((item, index) => {
      if(item.numero === numero){
        this.listaNumeros.splice(index, 1);
      }
    });
  }

  private configTable(){
    return {
      data: this.listaNumeros,
      retrieve: true,
      bAutoWidth: true,
      paging: true,
      searching: false,
      info: true,
      lengthChange: false,
      dom: $.ats._dataTableDomSemTableResponsive(),
      lengthMenu: [[3, 5, 10, 25, 50], [3, 5, 10, 25, 50]],
      order: [[0, 'asc']],
      sPaginationType: 'simple_numbers',
      columnDefs: [{ targets: 0, data: 'numero'},
                   { targets: 1, data: 'numero', className: 'text-center', width: 30, orderable: false,  render: function (data, type, row, meta) {
                    return '<button type="button" title="Excluir o número" data-numero="'+row.numero+'" class="btn btn-danger btn-xs btn-remove-numero"><i class="fa fa-times"></i></button>';
                   }}
                  ],
      language: $.ats._dataTableLanguage('Digite aqui sua pesquisa...')

    };
  }

  onEnviarSms(event){
    if(UtilService.empty(this.listaNumeros)){
      this.toasterUtil.alerta('Não foi informado nenhum número de celular.');
      return
    }

    if(!this.tempForm.controls['mensagem'].valid){
      this.toasterUtil.alerta('Favor verificar o campo da mensagem.');
      return
    }
    let retorno: Array<SMSModel> = [];

    this.listaNumeros.forEach((item, index) => {
      let sms: SMSModel = new SMSModel();
      sms.numero = item.numero;
      sms.mensagem = this.tempForm.controls['mensagem'].value;
      retorno.push(sms);
    });

    this.cadastroModalUtil.modelSelect = retorno;
    this.cadastroModalUtil.closeModal();
  }

  onCloseModal(event){
    this.cadastroModalUtil.closeModal();
  }

  onClickAdicionarTelefone(event){

    if (this.tempForm.controls['telefone'].valid){
      let aux : SMSModel = new SMSModel();
      aux.numero = this.tempForm.controls['telefone'].value;
      this.listaNumeros.push(aux);
      this.tempForm.controls['telefone'].setValue(null);
      this.refreshTable();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/componentes/enviar-sms/enviar-sms.component.ts